import api from "@helpers/api";
import {
  AddToStockType,
  ProductType,
  TagProductType,
} from "@type/inventory/procurements";

const apiEndPoint = `${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_BASE_URL}${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_PORT}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE}/api/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_VERSION}/${process.env.REACT_APP_EMPLOYEE_INVENTORY_SERVICE_TYPE}`;

const PRODUCT = "products";
const STOCK = "product-procurement/stock";

export const getProductDetails = (() => {
  return async (id: string): Promise<{ data: any }> => {
    return api.get(`${apiEndPoint}/${PRODUCT}/${id}`).then((response) => {
      return { data: response.data };
    });
  };
})();

export const updateProductDetails = (() => {
  return async (
    id: string | number,
    data: ProductType,
  ): Promise<{ data: any; error: any }> => {
    try {
      const res = await api.put(`${apiEndPoint}/${PRODUCT}/${id}`, {
        ...data,
      });

      return { data: res, error: null };
    } catch (error) {
      // Handle the error here
      return { data: null, error: error };
    }
  };
})();

export const tagProduct = (() => {
  return async (
    id: string | number,
    data: TagProductType[],
  ): Promise<{ data: any; error: any }> => {
    try {
      const res = await api.post(`${apiEndPoint}/${PRODUCT}/${id}/tags`, data);

      return { data: res, error: null };
    } catch (error) {
      // Handle the error here
      return { data: null, error: error };
    }
  };
})();

export const addToStock = (() => {
  return async (data: AddToStockType): Promise<{ data: any; error: any }> => {
    try {
      const res = await api.post(`${apiEndPoint}/${STOCK}`, data);

      return { data: res, error: null };
    } catch (error) {
      // Handle the error here
      return { data: null, error: error };
    }
  };
})();

export const addProduct = async (data: any) => {
  try {
    const res = await api.post(`${apiEndPoint}/${PRODUCT}`, data);

    return { data: res, error: null };
  } catch (error) {
    return { data: null, error: error };
  }
};
